import { yupResolver } from '@hookform/resolvers/yup'
import { useAtomValue } from 'jotai'
import { useForm, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useFormFields } from 'hooks/forms/useFormFields'
import { useWalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { generateReference } from 'utils/utils'
import { convertFromWalletAtom } from '../atoms/atoms'
import {
  ConvertDetailsForm,
  ConvertDetailsFormKeys,
  convertDetailsSchema,
} from '../schemas/convertDetailsSchema'

export const useConvertDetailsForm = () => {
  const { t } = useTranslation()
  const [walletAction] = useWalletActionContext()
  const convertFromWallet = useAtomValue(convertFromWalletAtom)
  const formSchema = convertDetailsSchema(t)

  const form = useForm<ConvertDetailsForm>({
    defaultValues: {
      fromWallet: walletAction?.meta?.sourceWallet?.lsid || convertFromWallet?.lsid,
      toWallet: '',
      reference: generateReference(),
    },
    resolver: yupResolver(formSchema),
  })

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = form

  const formValues = useWatch({ control }) as ConvertDetailsForm

  const { setComboboxField, setInputField } = useFormFields<ConvertDetailsFormKeys>(
    formSchema,
    form,
    formValues
  )

  const formFields: { [key in ConvertDetailsFormKeys] } = {
    fromWallet: setComboboxField({
      key: 'fromWallet',
      items: [],
    }),
    toWallet: setComboboxField({
      key: 'toWallet',
      items: [],
    }),
    fromAmount: setInputField({
      key: 'fromAmount',
    }),
    toAmount: setInputField({
      key: 'toAmount',
    }),
    reference: setInputField({
      key: 'reference',
    }),
  }

  return {
    form,
    formValues,
    errors,
    isSubmitting,
    formFields,
    handleSubmit,
    setValue,
  }
}
